"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function ArchiveIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("rect", { x: "8.905", y: "13.057", width: "6.19", height: "1.699" }),
        react_1.default.createElement("path", { d: "M23.172,8.593l-3-4.906a.849.849,0,0,0-.725-.407H4.553a.849.849,0,0,0-.725.407l-3,4.906a.85.85,0,0,0,.725,1.293h.633V19.87a.85.85,0,0,0,.85.85H20.964a.85.85,0,0,0,.85-.85V9.886h.633a.85.85,0,0,0,.725-1.293ZM5.029,4.979H18.971l1.96,3.208H3.069ZM20.114,19.021H3.886V9.886H20.114" })));
}
exports.default = ArchiveIcon;
